import { createElement } from 'react'

import { findAll } from 'highlight-words-core'

interface HighlightTextProps {
    textToHighlight: string
    searchTerm: string
}

const TextHighlighter = ({ textToHighlight, searchTerm }: HighlightTextProps) => {
    const safeText = typeof textToHighlight === 'string' ? textToHighlight : ''
    const safeSearchTerm = typeof searchTerm === 'string' ? searchTerm : ''
    // Split the text by the search term and include the term itself in the result
    const searchWords = safeSearchTerm.split(' ').map(v => v.replace(/[.*+?^${}()|[\]\\]/g, '')).filter(Boolean) // remove backslash as it conflicts with regex pattern
    const chunks = searchWords.length > 0 ? findAll({ searchWords, textToHighlight: safeText }) : undefined

    return createElement('span', {

        children: chunks ? chunks.map((chunk, index) => {
            const { end, highlight, start } = chunk
            if (!safeText) {
                console.log(safeSearchTerm, safeText)
            }
            const text = safeText.substring(start, end)
            if (highlight) {
                return createElement('em', { key: index }, text)
            } else {
                return text
            }
        }) : safeText
    })
}
export default TextHighlighter